"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoclipsKeycloakSecurity = void 0;
var axios_1 = __importDefault(require("axios"));
var keycloak_js_1 = __importDefault(require("keycloak-js"));
var extractEndpoint_1 = require("./extractEndpoint");
var getKeycloakToken_1 = require("./getKeycloakToken");
var BoclipsKeycloakSecurity = /** @class */ (function () {
    function BoclipsKeycloakSecurity(_a) {
        var options = _a.options, _b = _a.configureAxios, configureAxios = _b === void 0 ? true : _b, _c = _a.axiosInstance, axiosInstance = _c === void 0 ? axios_1.default : _c, _d = _a.host, host = _d === void 0 ? window.location.hostname : _d;
        var _this = this;
        this.keycloakInstance = null;
        this.initialiseKeycloakWithCredentials = function (authEndpoint, options) {
            (0, getKeycloakToken_1.getKeycloakToken)({
                client_id: options.clientId,
                realm: options.realm,
                authEndpoint: authEndpoint,
                username: options.username,
                password: options.password,
                grant_type: 'password',
                scope: 'openid',
            })
                .then(function (_a) {
                var _b = _a.data, token = _b.access_token, refreshToken = _b.refresh_token, idToken = _b.id_token;
                _this.initialiseKeycloak({ token: token, refreshToken: refreshToken, idToken: idToken }, options);
            })
                .catch(function () {
                options.onFailure && options.onFailure();
            });
        };
        this.initialiseKeycloak = function (extraInitOptions, _a) {
            var onLogin = _a.onLogin, onFailure = _a.onFailure, _b = _a.checkLoginIframe, checkLoginIframe = _b === void 0 ? true : _b;
            _this.keycloakInstance
                .init(__assign({ onLoad: 'check-sso', checkLoginIframe: checkLoginIframe, silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html', pkceMethod: 'S256' }, extraInitOptions))
                .then(function (authenticated) {
                if (authenticated) {
                    onLogin(_this.keycloakInstance);
                }
                else {
                    onFailure && onFailure();
                    if (_this.requireLoginPage) {
                        _this.keycloakInstance.login();
                    }
                }
            }, function (error) {
                console.error('An error occurred trying to login', error);
                onFailure && onFailure();
            });
        };
        this.isAuthenticated = function () {
            return !!(_this.keycloakInstance.authenticated && _this.keycloakInstance.token);
        };
        this.configureAxios = function (axiosInstance) { return __awaiter(_this, void 0, void 0, function () {
            var tokenFactory;
            var _this = this;
            return __generator(this, function (_a) {
                tokenFactory = this.getTokenFactory(5);
                axiosInstance.interceptors.request.use(function (config) { return __awaiter(_this, void 0, void 0, function () {
                    var token, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, tokenFactory()];
                            case 1:
                                token = _a.sent();
                                config.headers.Authorization = "Bearer ".concat(token);
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                console.warn('Caught error getting fresh token.');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/, config];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        this.ssoLogin = function (options) {
            _this.keycloakInstance.login(options);
        };
        this.logout = function (options) {
            _this.keycloakInstance.logout(options);
        };
        this.getTokenFactory = function (minValidity) { return function () {
            return new Promise(function (resolve, reject) {
                _this.keycloakInstance.updateToken(minValidity).then(function () {
                    return resolve(_this.keycloakInstance.token);
                }, function () {
                    if (_this.requireLoginPage) {
                        _this.keycloakInstance.login();
                    }
                    reject(false);
                });
            });
        }; };
        this.getKeycloakInstance = function () { return _this.keycloakInstance; };
        this.hasRole = function (role) {
            var _a, _b, _c;
            return (((_c = (_b = (_a = _this.keycloakInstance) === null || _a === void 0 ? void 0 : _a.realmAccess) === null || _b === void 0 ? void 0 : _b.roles) === null || _c === void 0 ? void 0 : _c.indexOf(role)) > -1 &&
                _this.isAuthenticated());
        };
        var url = options.authEndpoint || (0, extractEndpoint_1.extractEndpoint)(host, 'login');
        this.requireLoginPage = options.requireLoginPage;
        this.keycloakInstance = new keycloak_js_1.default({
            url: url,
            realm: options.realm,
            clientId: options.clientId,
        });
        options.username && options.password
            ? this.initialiseKeycloakWithCredentials(url, options)
            : this.initialiseKeycloak({}, options);
        if (configureAxios) {
            this.configureAxios(axiosInstance);
        }
    }
    return BoclipsKeycloakSecurity;
}());
exports.BoclipsKeycloakSecurity = BoclipsKeycloakSecurity;
